import { Box } from "@mui/material";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { useEffect } from "react";
import { useAppSelector } from "redux/hooks";
import { selectActiveFirmIdN } from "redux/slices/client";
import {
  fetchReviewerStats,
  selectReviewerBackPeriod,
  selectReviewerStats,
  selectReviewerTimeUnit,
  selectReviewerTimeWhen,
} from "redux/slices/clientLens";
import { selectMyUserId } from "redux/slices/session";
import theme from "theme";
import { P } from "theme/typography";

interface PersonalStatsProps {
  lensId: number;
}

const PersonalStats = (props: PersonalStatsProps) => {
  const { lensId } = props;
  const myUserId = useAppSelector(selectMyUserId);
  const snackpatch = useAppDispatchWithSnackbar();
  const timeUnit = useAppSelector(selectReviewerTimeUnit);
  const backPeriod = useAppSelector(selectReviewerBackPeriod);
  const stats = useAppSelector(selectReviewerStats);
  const activeFirmId = useAppSelector(selectActiveFirmIdN);
  const timeWhen = useAppSelector(selectReviewerTimeWhen);
  const totalPages = stats.pagesTotalCount;

  useEffect(() => {
    if (lensId && myUserId !== undefined) {
      snackpatch(
        fetchReviewerStats({
          lensId,
          assigneeId: myUserId,
          unit: timeUnit,
          backPeriod,
          firmId: activeFirmId,
        }),
        {
          errorMessage: "Failed to fetch reviewer stats",
        }
      );
    }
  }, [lensId, myUserId, timeUnit, backPeriod, activeFirmId]);

  if (stats.reviewsCompletedCount > 0) {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            borderBottom: `1px solid ${theme.palette.grey[200]}`,
            pb: 1,
            mb: 1,
          }}>
          <P variant="subtitle1">
            <strong>{stats.reviewsCompletedCount.toLocaleString()}</strong> completed reviews
          </P>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <P variant="subtitle1">
            Pattern analyzed <strong>{totalPages.toLocaleString()}</strong> pages
          </P>
        </Box>
      </>
    );
  } else {
    return (
      <P variant="subtitle1">
        You {backPeriod > 0 ? "did" : "have"} not completed any reviews{" "}
        <strong>{`${timeWhen.substring(0, 4)} ${timeWhen.substring(4)}`}</strong>. Complete a review or select a
        different time period to see review statistics.
      </P>
    );
  }
};

export default PersonalStats;
